module.exports = __webpack_public_path__ + "img/clima-0.753cbb53.png";